import LoadsPool from './loads-pool';

export default LoadsPool;
